<!-- 捐赠指数 -->
<template>
  <div class="donationIndex">
    <!-- 轮播图 -->
    <div class="swipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(image, index) in swipe" :key="index">
          <van-image :src="image.image" alt="轮播图" class="swipeImg" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="messageDiv clearfix" style="height: 50px;">
      <div class="messageIconDiv clearfix">
        <div class="messageIcon">
          <img
            src="../../assets/image/donation/btn_juanzeng_nor.png"
            alt="捐赠寄语"
            class="messageIconImg"
          />
        </div>
        <div class="messageIconWord">捐赠寄语</div>
      </div>
      <div class="messageDivision"></div>
      <div class="donationMessageDiv" @click="gotoMessage">
        <div class="scroll-container">
          <div
            class="scroll-wrapper"
            :style="{ transform: `translateY(${offset}px)` }"
          >
            <div
              v-for="(item, index) in message"
              :key="index"
              class="scroll-item"
            >
              {{ item.message }}
            </div>
            <div
              v-for="(item, index) in message"
              :key="`copy-${index}`"
              class="scroll-item"
            >
              {{ item.message }}
            </div>
          </div>
        </div>
      </div>
      <div class="messageMoreIconDiv" @click="gotoMessage">
        <img
          src="../../assets/image/btn_gengduo_nor.png"
          alt="更多"
          class="messageMoreIcon"
        />
      </div>
    </div>
    <div class="recommendDiv">
      <!-- <div class="titleDiv">
        <div class="titleIcon"></div>
        <div class="titleWord">推荐项目</div>
        <button class="titleMore" @click="gotoList">更多</button>
      </div> -->

      <div class="FirstLevelTitle">
        <div>推荐项目</div>
        <div @click="gotoList">更多</div>
      </div>
      <div
        class="recommend"
        v-for="item in (donation || []).filter((item) => item.recommend == 1)"
        :key="item.id"
        @click="gotoDonationDetial(item.id)"
      >
        <!-- recommend==1推荐项目 -->
        <div class="recommendImgDiv" v-if="item.recommend == 1">
          <div
            class="recommendTipDiv"
            v-if="item.id % 2 == 0"
            style="background: linear-gradient(-90deg, #00706e, #00706e)"
          >
            <div class="recommendTipWord">{{ item.typeName }}</div>
          </div>
          <div
            class="recommendTipDiv"
            v-else
            style="background: linear-gradient(-90deg, #00706e, #00706e)"
          >
            <div class="recommendTipWord">{{ item.typeName }}</div>
          </div>
          <img :src="item.images" alt="项目图片" class="recommendImg" />
          <!-- <div class="supportNumDiv">
            <div class="supportNum">支持人数 {{ item.persons }} 人</div>
          </div> -->
        </div>
        <div class="recommendCardDiv clearfix" v-if="item.recommend == 1">
          <div class="recommendName">{{ item.title }}</div>
          <div class="recommendState" v-if="item.status == 3">未开始</div>
          <div class="recommendState" v-else-if="item.status == 1">进行中</div>
          <div class="recommendState" v-else>已结束</div>
          <div class="maxMoney">目标金额：￥{{ item.targetAmount }}元</div>
          <div class="nowMoney">已筹金额：￥{{ item.hasAmount }}元</div>
          <!-- <div class="percentageDiv clearfix">
            <div class="percentageWord">捐款进度</div>
            <van-progress
              :percentage="(item.hasAmount / item.targetAmount) * 100"
              stroke-width="15"
              :show-pivot="false"
              class="percentage"
            />
            <div class="percentageNum">
              {{
                ((item.hasAmount / item.targetAmount) * 100 + "").substring(
                  0,
                  3
                ) + "%"
              }}
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="rankingAndMyDonation" v-show="false">
      <div class="ranking" @click="gotoRankingList">捐赠排行</div>
      <hr />
      <div class="myDonation" @click="gotoMyDonation">我的捐赠</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swipe: [],
      message: [],
      donation: "",
      timer: null,
      animate: false,
      offset: 0, // 当前位置偏移
      interval: null, // 定时器
    };
  },
  created() {
    this.getSwipe();
    this.getDonationList();
    this.getMessage();
  },
  mounted() {
    // 设置定时器进行滚动
    this.interval = setInterval(this.scroll, 2000); // 每2秒滚动一次
  },
  beforeDestroy() {
    // 清除定时器
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  computed: {
    // 副本列表项，确保无限滚动效果
    copyItems() {
      return [...this.message, ...this.message];
    },
  },
  methods: {
    async getSwipe() {
      const result = await this.$http.get("/donates/getBanners");
      this.swipe = result.data || [];
    },
    async getDonationList() {
      const result = await this.$http.get("/donates/getDonates", {
        params: { currentPage: 1, perpage: 50 },
      });
      this.donation = result.data.list;
    },
    async getMessage() {
      const result = await this.$http.get("/donates/getDonateRecord", {
        params: { currentPage: 1, perPage: 5 },
      });
      if (result.data.list == []) {
        this.message = "";
      } else {
        this.message = result.data.list;
      }
    },
    gotoDonationDetial(id) {
      console.log("id", id);
      return this.$router.push({
        path: "/donationDetail",
        query: { id: id },
      });
    },
    gotoMessage() {
      return this.$router.push("/donationMessage");
    },
    gotoList() {
      return this.$router.push("/donationList");
    },
    gotoMyDonation() {
      return this.$router.push("/myDonation");
    },
    gotoRankingList() {
      return this.$router.push("/ranking");
    },

    scroll() {
      this.offset -= this.$el.querySelector(".scroll-item").clientHeight; // 获取单个列表项的高度
      // this.offset = scrollHeight; // 更新偏移量
      // // 当滚动到底部时，重置偏移量
      // if (this.offset <= -this.message.length * scrollHeight) {
      //   this.offset = 0;
      // }
    },
  },
};
</script>
<style lang="less" scoped>
.scroll-container {
  overflow: hidden;
  position: relative;
  height: 40px; /* 根据需要设置容器高度 */
  margin-top: 5px;
}

.scroll-wrapper {
  position: absolute;
  width: 100%;
  height: 100%; /* 根据需要设置容器高度 */
  transition: transform 0.5s ease-in-out; /* 平滑滚动效果 */
}

.scroll-item {
  height: 40px; /* 根据需要设置列表项高度 */
  line-height: 40px; /* 根据需要设置列表项行高 */
  text-align: center;
  /* 设置不允许换行，注意根据实际内容可能需要使用word-break: break-all; */
  white-space: nowrap;
  overflow: hidden;
}
.donationIndex {
  position: relative;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  text-align: center;
}

.swipeImg {
  height: 13.03rem;
  width: 100%;
}

.messageDiv {
  margin-top: 20px;
  position: relative;
  left: 5%;
  width: 90%;
  background-color: white;
  border-radius: 15px;
}

.messageIconDiv {
  width: 35%;
  height: 100%;
  float: left;
}

.messageIcon {
  float: left;
}

.messageIconImg {
  width: 50%;
  // padding: 20px 0px 20px 5px;
  padding: 10px 0px 10px 7px;
}

.messageIconWord {
  float: right;
  font-size: 1.1rem;
  color: #00706e;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
}

.messageDivision {
  position: absolute;
  left: 33%;
  top: 50%;
  transform: translateY(-50%);
  float: left;
  height: 60%;
  background-color: #dedede;
  width: 2px;
  font-size: 0.95rem;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.donationMessageDiv {
  // position: relative;
  width: 50vw;
  height: 60px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-size: 0.85rem;
  .donationMessage {
    // position: relative;
    // color: #333333;
    // width: 100%;
    // // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 1;
    // -webkit-box-orient: vertical;
    // line-height: 1.67rem;
    width: 50vw;
    height: 40px;
    display: flex;
    flex-direction: column;

    .list-item {
      height: 40px; /* 你可以根据需要调整这个值 */
      line-height: 35px; /* 垂直居中 */
      cursor: pointer; /* 鼠标悬停时变为手型，表示可点击 */
      transition: top 0.5s;
    }

    .scrollable-view-list {
      height: 100px; /* 设置固定高度 */
      overflow-y: auto; /* 使内容可以垂直滚动 */
      border: 1px solid #000; /* 边框，可视化滚动效果 */
      background: #dedede;
    }

    .noticeTitle {
      width: 55vw;
      margin: 5px 5px 5px 3px;
      font-size: 0.95rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.messageMoreIconDiv {
  position: absolute;
  left: 94%;
  top: 50%;
  transform: translateY(-50%);
}

.messageMoreIcon {
  width: 60%;
}

.recommendDiv {
  margin-top: 20px;
  position: relative;
  left: 5%;
  width: 90%;
}

.titleDiv {
  height: 7vw;
}

.titleIcon {
  float: left;
  width: 4px;
  height: 6vw;
  background-color: #00706e;
  border-radius: 15px;
}

.titleWord {
  float: left;
  position: absolute;
  left: 10px;
  font-size: 1.3em;
  font-weight: bold;
}

.titleMore {
  float: right;
  border: 0;
  background: #f5f5f5;
  font-size: 1.07rem;
  color: #00706e;
}

.recommend {
  margin: 20px 0px 20px 0px;
  border: 0.04px solid #e1e1e1;
  border-radius: 15px;
  overflow: hidden;
}

.recommendImgDiv {
  position: relative;
  width: 100%;
  height: 20vh;
}

.recommendImg {
  width: 100%;
  height: 100%;
  // border-radius: 15px 15px 0 0;
}

.recommendTipDiv {
  position: absolute;
  left: 0%;
  top: 0%;
  width: 35%;
  height: 25px;
  line-height: 25px;
  border-radius: 15px 0px 15px 0px;
}

.recommendTipWord {
  // position: absolute;
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -60%);
  color: white;
  white-space: nowrap;
  text-align: center;
}

.recommendTip {
  width: 100%;
}

.supportNumDiv {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #000000;
  opacity: 0.7;
}

.supportNum {
  float: right;
  color: white;
  padding: 5px 10px 5px 0px;
}

.recommendCardDiv {
  background-color: white;
  // border-radius: 0px 0px 15px 15px;
}

.recommendName {
  float: left;
  width: 80%;
  font-size: 1rem;
  font-weight: bold;
  margin: 5px 0px 5px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.recommendState {
  float: right;
  width: 14%;
  color: #00706e;
  font-size: 1rem;
  font-weight: bold;
  padding: 5px 5px 5px 0px;
}

.maxMoney {
  float: left;
  color: #666666;
  padding: 5px 0px 5px 10px;
  width: 50%;
  font-size: 0.9rem;
}

.nowMoney {
  float: right;
  color: #666666;
  margin: 5px 0px 5px 0px;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 0.9rem;
}

.percentageDiv {
  float: left;
  width: 100%;
  margin-bottom: 10px;
}

.percentageWord {
  float: left;
  color: #666666;
  padding: 5px 0px 5px 10px;
  font-size: 0.9rem;
}

.percentage {
  float: left;
  width: 60%;
  margin: 5px 0px 5px 10px;
}

.percentageNum {
  float: right;
  color: #666666;
  padding: 5px 10px 5px 0px;
}

.rankingAndMyDonation {
  position: fixed;
  top: 28rem;
  right: 0;
  background-color: black;
  color: white;
  opacity: 0.8;
  border-radius: 15px 0px 0px 15px;
}

.ranking {
  padding: 10px 10px 5px 10px;
}

.myDonation {
  padding: 5px 10px 10px 10px;
}

hr {
  width: 90%;
  border-top: 0.5px solid #ffffff;
  margin-block-start: 0em;
  margin-block-end: 0em;
  border-style: solid;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/DonationIndex.vue